import { render, staticRenderFns } from "./CardPropertiesGraph.vue?vue&type=template&id=cca79718"
import script from "./CardPropertiesGraph.vue?vue&type=script&lang=js"
export * from "./CardPropertiesGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports